import { render } from "./UnderstandingYourTyres.vue?vue&type=template&id=12909ecd&scoped=true"
import script from "./UnderstandingYourTyres.vue?vue&type=script&lang=js"
export * from "./UnderstandingYourTyres.vue?vue&type=script&lang=js"

import "./UnderstandingYourTyres.vue?vue&type=style&index=0&id=12909ecd&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12909ecd"]])

export default __exports__